'use client';

import Image from 'next/image';
import Link from 'next/link';
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'

interface WrittenByProps {
  data: {
    heading?: {
      title?: string
    }
    text?: {
      text?: string
    }
    options_page: string[]
    background: string
    id_section: string
    class_section: string
    image?: {
      alt: string
      image_file: {
        image: {
          id: string
          filename_disk: string
        }
      }
    }
    button?: {
      label?: string
      href?: string
    }
  }
}

export const fields = [
	// headings
	'heading.title',
	// text
	'text.text',
	// image
	'image.alt',
	'image.image_file.image.id',
	'image.image_file.image.filename_download',

	'button.label',
	'button.href',
] as const

export default function WrittenBy({ data }: WrittenByProps) {
  return (
		<section className='WrittenBy py-16 3xl:py-32 bg-[#e8ddd3]'>
			<div className='container'>
				<div className='w-full flex flex-col md:flex-row gap-8 md:gap-20 items-center'>
					<div className='w-full aspect-square md:w-[294px] md:h-[294px] relative'>
						{data?.image?.image_file?.image?.id ? (
							<Image
								src={getReadableImageUrl(
									data.image.image_file.image.id,
									data.image.image_file.image.filename_disk || ''
								)}
								alt={data.image?.alt || ''}
								fill
								className='object-cover'
								sizes='(max-width: 768px) 100vw, 294px'
								priority
							/>
						) : null}
					</div>
					<div className='flex-1 flex flex-col gap-6'>
						{data?.heading?.title && (
							<h2 className='max-md:text-3xl'>{data.heading.title}</h2>
						)}
						<div
							className='grid gap-6 text-center md:text-left'
							dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
						/>

						{data?.button?.label && (
							<Link href={data.button?.href || '/'} className='btn'>
								{data.button.label}
							</Link>
						)}
					</div>
				</div>
			</div>
		</section>
	)
}